"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var RequestLookupType;
(function (RequestLookupType) {
    RequestLookupType[RequestLookupType["None"] = 0] = "None";
    RequestLookupType[RequestLookupType["PackIdentifer"] = 1] = "PackIdentifer";
    RequestLookupType[RequestLookupType["UPRC"] = 2] = "UPRC";
    RequestLookupType[RequestLookupType["TransactionId"] = 3] = "TransactionId";
})(RequestLookupType = exports.RequestLookupType || (exports.RequestLookupType = {}));
//# sourceMappingURL=RequestLookupType.js.map